import { useCallback, useEffect } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { StellarTechLogo } from 'assets/icons';
import { Link } from 'components/tools';
import { Button, Icon, Spinner } from 'components/ui/general';
import { ClientPaths } from 'consts/router';
import { useToast } from 'hooks';
import { logoutStart } from 'redux/auth';
import { useMeQuery } from 'types/graphql';

import { texts } from './ClientHeader.texts';

import styles from './ClientHeader.module.scss';

export const ClientHeader = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useMeQuery();
  const { addToast } = useToast();

  const getName = useCallback(() => {
    if (!data?.me) {
      return 'UserName';
    }
    return `${data?.me?.firstName} ${data?.me?.lastName}`;
  }, [data]);

  const getInitials = useCallback(() => {
    if (!data?.me) {
      return 'UN';
    }
    return `${data?.me?.firstName[0]}${data?.me?.lastName[0]}`;
  }, [data]);

  useEffect(() => {
    if (error) {
      addToast({
        title: 'Error',
        type: 'error'
      });
    }
  }, [addToast, error]);

  return (
    <header className={styles.root}>
      <div className={styles.left}>
        <Link to={ClientPaths.sendMessages} className={styles.flex}>
          <StellarTechLogo className={styles.logo} />
        </Link>
        <Link
          to={ClientPaths.sendMessages}
          className={({ isActive }) =>
            classNames(styles.link, {
              [styles.isActive]: isActive
            })
          }
        >
          <Button
            color="nav"
            iconLeft={{ name: 'paper-plane', font: 'hedemora' }}
            className={styles.navButton}
          >
            <FormattedMessage {...texts.sendMessages} />
          </Button>
        </Link>
        <Link
          to={ClientPaths.Contacts}
          className={({ isActive }) =>
            classNames(styles.link, {
              [styles.isActive]: isActive
            })
          }
        >
          <Button
            color="nav"
            iconLeft={{ name: 'address-card', font: 'hedemora' }}
            className={styles.navButton}
          >
            <FormattedMessage {...texts.contacts} />
          </Button>
        </Link>
        <Link
          to={ClientPaths.settings}
          className={({ isActive }) =>
            classNames(styles.link, {
              [styles.isActive]: isActive
            })
          }
        >
          <Button
            color="nav"
            iconLeft={{ name: 'cog', font: 'hedemora' }}
            className={styles.navButton}
          >
            <FormattedMessage {...texts.settings} />
          </Button>
        </Link>
      </div>
      <div className={styles.right}>
        <div className={styles.logoutContainer}>
          <div className={styles.imageAndNameContainer}>
            {!loading ? (
              <>
                <div className={styles.profilePic}>{getInitials()}</div>
                <div className={styles.nameContainer}>
                  <div className={styles.profileName}>{getName()}</div>
                </div>
              </>
            ) : (
              <Spinner visible={loading} />
            )}
          </div>
          <Button
            stripPadding
            naked
            type="button"
            className={styles.logoutButton}
            onClick={() => dispatch(logoutStart())}
          >
            <Icon name="sign-out" className={styles.logoutIcon} />
          </Button>
        </div>
      </div>
    </header>
  );
};
